import { ToastrModule } from 'ngx-toastr';
import { ModalComponent } from './modal/modal.component';
import { ProgressBarComponent } from './controls/progress-bar/progress-bar.component';
import { FormUtils } from './FormUtils';
import { CircleGreenRedPipe } from './pipes/circle-green-red.pipe';
// tslint:disable:max-line-length
import { VisitorCardAccountDetailsComponent } from './cardholders/visitor-cards/visitor-card-account-details/visitor-card-account-details.component';
import { WebAlertComponent } from './users-view/web-alert/web-alert.component';
import { MerchantAchFundingComponent } from './merchants/merchant-ach-funding/merchant-ach-funding.component';
import { MerchantNotesComponent } from './merchants/merchant-notes/merchant-notes.component';
// tslint:disable:max-line-length
import { VisitorCardSearchComponent } from './cardholders/visitor-cards/visitor-card-search/visitor-card-search.component';
import { VisitorCardAccountsComponent } from './cardholders/visitor-cards/visitor-card-accounts/visitor-card-accounts.component';
import { VisitorCardDetailsComponent } from './cardholders/visitor-cards/visitor-card-details/visitor-card-details.component';
import { SearchComponent } from './cardholders/search/search.component';
import { PersonalComponent } from './cardholders/personal/personal.component';
import { CardholderFormsHistoryComponent } from './cardholders/forms-history/forms-history.component';
import { HistoryComponent } from './cardholders/history/history.component';
import { CardholderProfilesComponent } from './cardholders/cardholder-profiles/cardholder-profiles.component';
import { CardholderDetailsComponent } from './cardholders/cardholder-details/cardholder-details.component';
import { AccountsComponent } from './cardholders/accounts/accounts.component';
import { MerchantSettlementComponent } from './merchants/merchant-settlement/merchant-settlement.component';
import { MerchantSearchComponent } from './merchants/merchant-search/merchant-search.component';
import { MerchantProfilesComponent } from './merchants/merchant-profiles/merchant-profiles.component';
import { MerchantHistoryComponent } from './merchants/merchant-history/merchant-history.component';
import { MerchantDetailsComponent } from './merchants/merchant-details/merchant-details.component';
import { MerchantAccountsComponent } from './merchants/merchant-accounts/merchant-accounts.component';
import { EntitlementGuard } from './services/entitlement.guard';
import { LoginGuard } from './services/login.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2TableModule } from './ng-table/ng-table.module';
import { HelpComponent, HelpFilterPipe } from './help/help.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { UserMessagesComponent } from './user/user-messages/user-messages.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MerchantAdjustmentsComponent } from './merchants/merchant-adjustments/merchant-adjustments.component';
import { ShipProfilesComponent } from './ships/ship-profiles/ship-profiles.component';
import { NavigationFooterComponent } from './navigation-footer/navigation-footer.component';
import { NavigationSidebarFooterComponent } from './navigation-sidebar-footer/navigation-sidebar-footer.component';
import { NavigationSidebarComponent } from './navigation-sidebar/navigation-sidebar.component';
import { FormsUploadComponent } from './forms-view/forms-upload/forms-upload.component';
import { FormsViewSearchComponent } from './forms-view/forms-view-search/forms-view-search.component';
import { SearchFormExistsComponent } from './forms-view/search-form-exists/search-form-exists.component';
import { ShipReportsComponent } from './reports-view/ship-reports/ship-reports.component';
import { BulkCardsComponent } from './ships/bulk-cards/bulk-cards.component';
import { ShipContactsComponent } from './ships/ship-contacts/ship-contacts.component';
import { HullSwapsComponent } from './ships/hull-swaps/hull-swaps.component';
import { ShipMerchantsComponent } from './ships/ship-merchants/ship-merchants.component';
import { RoundTripsComponent } from './ships/round-trips/round-trips.component';
import { ShipDetailsComponent } from './ships/ship-details/ship-details.component';
import { ShipPasswordComponent } from './ships/ship-password/ship-password.component';
import { ShipRegisterComponent } from './ships/ship-register/ship-register.component';
import { ResetUserComponent } from './users-view/reset-user/reset-user.component';
import { NavigationTopComponent } from './navigation-top/navigation-top.component';
import { NavigationSubmenuComponent } from './navigation-submenu/navigation-submenu.component';
import { BulkTransfersComponent } from './bulk-transfers/bulk-transfers.component';
import { ActiveInactivePipe } from './pipes/active-inactive.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { MinusSignToParensPipe } from './pipes/minus-sign-to-parens.pipe';
import { YesNoStatusPipe } from './pipes/yes-no-status.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { ThreeStarsPipe } from './pipes/three-stars.pipe';
import { PhoneticColorPipe } from './pipes/phonetic-color.pipe';
import { AccountTypePipe } from './pipes/account-type.pipe';
import { BankingTypePipe } from './pipes/banking-type.pipe';
import { DropdownSelectControlComponent } from './controls/dropdown-select-control/dropdown-select-control.component';
import { MerchantSearchResultsComponent } from './merchants/merchant-search-results/merchant-search-results.component';
import { PaginationComponent } from './controls/pagination/pagination.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { MessagesComponent } from './messages/messages.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ShipSearchResultsComponent } from './ships/ship-search-results/ship-search-results.component';
import { ShipHeaderSearchComponent } from './ships/ship-header-search/ship-header-search/ship-header-search.component';
import { RoundTripOverviewComponent } from './ships/round-trips/round-trip-overview/round-trip-overview.component';
import { HoursSinceLastRoundtripPipe } from './pipes/hours-since-last-roundtrip.pipe';
import { ProcessingStatusPipe } from './pipes/processing-status.pipe';
import { FleetInformationComponent } from './ships/round-trips/fleet-information/fleet-information.component';
import { RoundTripHistoryComponent } from './ships/round-trips/round-trip-history/round-trip-history.component';
import { VisitorCardAdjustmentsComponent } from './cardholders/visitor-cards/visitor-card-adjustments/visitor-card-adjustments.component';
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbModule
} from '@ng-bootstrap/ng-bootstrap';
import { DateParserFormatter } from './reports-view/ship-reports/date.parser.formatter';
import { SearchResultsComponent } from './cardholders/search-results/search-results.component';
import { AchfundingComponent } from './cardholders/achfunding/achfunding.component';
import { CardholderAdjustmentsComponent } from './cardholders/cardholder-adjustments/cardholder-adjustments.component';
import { CardholderNotesComponent } from './cardholders/cardholder-notes/cardholder-notes.component';
import { CardholderVisaforwardComponent } from './cardholders/cardholder-visaforward/cardholder-visaforward.component';
import { CardholderVisahistoryComponent } from './cardholders/cardholder-visahistory/cardholder-visahistory.component';
import { VisitorCardSearchResultsComponent } from './cardholders/visitor-cards/visitor-card-search-results/visitor-card-search-results.component';
import { CardholderHeaderSearchComponent } from './cardholders/cardholder-header-search/cardholder-header-search.component';
import { VisitorCardsTransactionHistoryComponent } from './cardholders/visitor-cards/visitor-cards-transaction-history/visitor-cards-transaction-history.component';
import { ConfirmButtonComboComponent } from './controls/confirm-button-combo/confirm-button-combo.component';
import { Last4digitsPipe } from './pipes/last4digits.pipe';
import { MerchantVisahistoryComponent } from './merchants/merchant-visahistory/merchant-visahistory.component';
import { CardholderAccountDetailsComponent } from './cardholder/cardholder-account-details/cardholder-account-details.component';
import { CardholderHistoryComponent } from './cardholder/cardholder-history/cardholder-history.component';
import { CardholderOpenLoopHistoryComponent } from './cardholder/cardholder-open-loop-history/cardholder-open-loop-history.component';
import { GetKeysPipe } from './pipes/get-keys.pipe';
import { AccessDetailsComponent } from './ships/access-details/access-details.component';
import { SelfEnrollComponent } from './self-enrollment/self-enroll/self-enroll.component';
import { ServiceAndTermsComponent } from './self-enrollment/service-and-terms/service-and-terms.component';
import { ESignComponent } from './self-enrollment/e-sign/e-sign.component';
import { InformationComponent } from './self-enrollment/information/information.component';
import { CopyRightComponent } from './controls/copy-right/copy-right.component';
import { StoreModule } from '@ngrx/store';
import { reducers } from './store/app.reducers';
import { ESignPdfComponent } from './self-enrollment/pdf/esign/esignPdf.component';
import { TermsPdfComponent } from './self-enrollment/pdf/terms/termsPdf.component';
import { TermsLongPdfComponent } from './self-enrollment/pdf/terms-long/termsLongPdf.component';
import { TermsShortPdfComponent } from './self-enrollment/pdf/terms-short/termsShortPdf.component';
import { EmailVerificationComponent } from './self-enrollment/email-verification/email-verification.component';
import { VerificationInactiveComponent } from './self-enrollment/verification-inactive/verification-inactive.component';
import { VerificationInvalidComponent } from './self-enrollment/verification-invalid/verification-invalid.component';
import { PrivacyComponent } from './self-enrollment/Privacy/privacy.component';
import { VerificationValidComponent } from './self-enrollment/verification-valid/verification-valid.component';
import { ShipPendingComponent } from './ships/ship-pending/ship-pending.component';
import { ShipRegisterMerchantsComponent } from './ships/ship-register-merchants/ship-register-merchants.component';
import { MerchantFormsComponent } from './merchants/merchant-forms/merchant-forms.component';
import { DropzoneDirective } from './controls/file-upload/dropzone.directive';
import { FileUploaderComponent } from './controls/file-upload/file-uploader/file-uploader.component';
import { MaintainShipUserComponent } from './users-view/maintain-ship-user/maintain-ship-user.component';
import { ShipUserFormComponent } from './users-view/ship-user-form/ship-user-form.component';
import { ShipRosterComponent } from './ships/ship-roster/ship-roster.component';
import { ShipLogsComponent } from './ships/ship-logs/ship-logs.component';
import {CardOrderComponent} from './system/card-order/card-order.component';
import { MerchantVisaforwardComponent } from './merchants/merchant-visaforward/merchant-visaforward.component';
import { MarinesBulkEnrollmentComponent } from './ships/bulk-cards/marines/marines-bulk-enrollment/marines-bulk-enrollment.component';
import { VisaReportsComponent } from './reports-view/visa-reports/visa-reports.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2TableModule,
    ReactiveFormsModule,
    StoreModule.forRoot(reducers),
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgbModule,
    ToastrModule.forRoot({
      enableHtml: true,
      closeButton: true,
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true
    }),
    RouterModule.forRoot(
      [
        {path: 'login', component: LoginComponent},
        {path: 'resetQA', component: UserMessagesComponent},
        {path: 'resetPassword', component: UserMessagesComponent},
        {path: 'privacyPolicy', component: PrivacyPolicyComponent},
        {
          path: 'contact',
          component: ContactComponent
        },
        {path: 'help', component: HelpComponent},
        {
          path: 'selfEnroll',
          children: [
            {
              path: 'getStarted',
              component: SelfEnrollComponent
            },
            {
              path: 'e-sign',
              component: ESignComponent
            },
            {
              path: 'privacy',
              component: PrivacyComponent
            },
            {
              path: 'serviceAndTerms',
              component: ServiceAndTermsComponent
            },
            {
              path: 'information',
              component: InformationComponent
            },
            {
              path: 'verifyEmail',
              component: EmailVerificationComponent
            }
          ]
        },
        // {
        //   path: 'cardholderProfiles',
        //   children: [
        //     { path: '', component: SearchComponent },
        //     { path: 'accounts', component: AccountsComponent },
        //     { path: 'bulkTransfers', component: BulkTransfersComponent },
        //     { path: 'details', component: CardholderDetailsComponent },
        //     { path: 'history', component: HistoryComponent },
        //     { path: 'personal', component: PersonalComponent },
        //     { path: 'search', component: SearchComponent },
        //     {
        //       path: 'visitorCards',
        //       component: VisitorCardDetailsComponent,
        //       pathMatch: 'full'
        //     },
        //     {
        //       path: 'visitorCards/adjustments',
        //       component: VisitorCardAdjustmentsComponent
        //     },
        //     {
        //       path: 'visitorCards/details',
        //       component: VisitorCardDetailsComponent
        //     },
        //     {
        //       path: 'visitorCards/accounts',
        //       component: VisitorCardAccountsComponent
        //     },
        //     {
        //       path: 'visitorCards/serach',
        //       component: VisitorCardSearchComponent
        //     }
        //   ],
        //   canActivateChild: [LoginGuard, EntitlementGuard],
        //   canActivate: [LoginGuard, EntitlementGuard]
        // },
        {
          path: 'visitorCards',
          children: [
            {
              path: '',
              component: VisitorCardSearchComponent,
              pathMatch: 'full'
            },
            {
              path: 'adjustments',
              component: VisitorCardAdjustmentsComponent
            },
            {
              path: 'details',
              component: VisitorCardDetailsComponent
            },
            {
              path: 'accounts',
              component: VisitorCardAccountsComponent
            },
            {
              path: 'serach',
              component: VisitorCardSearchComponent
            }
          ],
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard]
        },
        {
          path: 'reports',
          children: [
            {
              path: 'shipReports',
              component: ShipReportsComponent
            }
          ],
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard]
        },
        {
        path: 'reports',
        children: [
          {
            path: 'visaReports',
            component: VisaReportsComponent
          }
        ],
        canActivateChild: [LoginGuard, EntitlementGuard],
        canActivate: [LoginGuard, EntitlementGuard]
      },
        {
          path: 'users',
          children: [
            {
              path: 'messages',
              component: UserMessagesComponent
            },
            {
              path: 'maintainShipUser',
              component: MaintainShipUserComponent
            }
          ],
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard]
        },
        {
          path: 'merchantProfiles',
          component: MerchantProfilesComponent,
          children: [
            {path: '', component: MerchantSearchComponent},
            {path: 'accounts', component: MerchantAccountsComponent},
            {path: 'adjustments', component: MerchantAdjustmentsComponent},
            {path: 'details', component: MerchantDetailsComponent},
            {path: 'history', component: MerchantHistoryComponent},
            {path: 'achFunding', component: MerchantAchFundingComponent},
            {path: 'settlement', component: MerchantSettlementComponent},
            { path: 'notes', component: MerchantNotesComponent },
            {path: 'visaForward', component: MerchantVisaforwardComponent},
            {path: 'mvisahistory', component: MerchantVisahistoryComponent},
            {path: 'merchantForms', component: MerchantFormsComponent}
          ],
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard]
        },
        {
          path: 'bulkTransfers',
          component: BulkTransfersComponent,
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard]
        },
        {
          path: 'shipProfiles',
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard],
          children: [
            {path: '', component: ShipProfilesComponent},
            {path: 'roundtrips', component: RoundTripsComponent},
            {path: 'merchants', component: ShipMerchantsComponent},
            {path: 'contacts', component: ShipContactsComponent},
            {path: 'bulkcards', component: BulkCardsComponent},
            {path: 'hullswaps', component: HullSwapsComponent},
            {path: 'accessDetails', component: AccessDetailsComponent},
            {path: 'ship-roster', component: ShipRosterComponent},
            {path: 'marines-bulk-enrollment', component: MarinesBulkEnrollmentComponent},
            {path: 'logs', component: ShipLogsComponent}
          ]
        },
        {
          path: 'cardholderProfiles',
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard],
          children: [
            {path: '', component: SearchComponent},
            {path: 'accounts', component: AccountsComponent},
            {path: 'history', component: HistoryComponent},
            {path: 'achFunding', component: AchfundingComponent},
            {path: 'adjustments', component: CardholderAdjustmentsComponent},
            {path: 'personal', component: PersonalComponent},
            {path: 'forms', component: CardholderFormsHistoryComponent},
            {path: 'notes', component: CardholderNotesComponent},
            {path: 'visaForward', component: CardholderVisaforwardComponent},
            {path: 'visahistory', component: CardholderVisahistoryComponent}
          ]
        },
        {
          path: 'cardholder',
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard],
          children: [
            {path: '', redirectTo: 'accountDetails', pathMatch: 'full'},
            {
              path: 'accountDetails',
              component: CardholderAccountDetailsComponent
            },
            {
              path: 'history',
              component: CardholderHistoryComponent
            },
            {
              path: 'openLoopHistory',
              component: CardholderOpenLoopHistoryComponent
            }
          ]
        },
        {
          path: 'formsUpload',
          component: FormsUploadComponent,
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard]
        },
        {
          path: 'system',
          canActivateChild: [LoginGuard, EntitlementGuard],
          canActivate: [LoginGuard, EntitlementGuard],
          children: [
            {path: '', redirectTo: 'cardOrder', pathMatch: 'full'},
            {
              path: 'cardOrder',
              component: CardOrderComponent
            }
          ]
        },
        {path: '', redirectTo: 'login', pathMatch: 'full'},
        {path: '**', redirectTo: 'login', pathMatch: 'full'}
      ],
      {useHash: true} // , enableTracing: true }
    )
  ],
  declarations: [
    AchfundingComponent,
    FleetInformationComponent,
    RoundTripHistoryComponent,
    HoursSinceLastRoundtripPipe,
    ProcessingStatusPipe,
    RoundTripOverviewComponent,
    ShipHeaderSearchComponent,
    ShipSearchResultsComponent,
    MerchantSearchResultsComponent,
    PaginationComponent,
    PhoneticColorPipe,
    ActiveInactivePipe,
    YesNoPipe,
    MinusSignToParensPipe,
    YesNoStatusPipe,
    SortPipe,
    AccountTypePipe,
    BankingTypePipe,
    CircleGreenRedPipe,
    CardholderNotesComponent,
    CardholderFormsHistoryComponent,
    CardholderVisaforwardComponent,
    CardholderVisahistoryComponent,
    HelpComponent,
    PrivacyPolicyComponent,
    LoginComponent,
    UserMessagesComponent,
    ContactComponent,
    MerchantAccountsComponent,
    MerchantHistoryComponent,
    MerchantDetailsComponent,
    MerchantProfilesComponent,
    MerchantSearchComponent,
    MerchantSettlementComponent,
    MerchantVisaforwardComponent,
    AccountsComponent,
    BulkTransfersComponent,
    CardholderDetailsComponent,
    CardholderProfilesComponent,
    CardholderHeaderSearchComponent,
    CardholderAdjustmentsComponent,
    HistoryComponent,
    PersonalComponent,
    SearchComponent,
    VisitorCardDetailsComponent,
    VisitorCardAccountsComponent,
    VisitorCardSearchComponent,
    MerchantAchFundingComponent,
    MerchantNotesComponent,
    MerchantAdjustmentsComponent,
    WebAlertComponent,
    BulkTransfersComponent,
    ShipProfilesComponent,
    NavigationFooterComponent,
    NavigationSidebarFooterComponent,
    NavigationSidebarComponent,
    FormsUploadComponent,
    FormsViewSearchComponent,
    SearchFormExistsComponent,
    ShipReportsComponent,
    BulkCardsComponent,
    ShipContactsComponent,
    HullSwapsComponent,
    ShipMerchantsComponent,
    RoundTripsComponent,
    ShipDetailsComponent,
    ShipPasswordComponent,
    ShipRegisterComponent,
    ShipRegisterMerchantsComponent,
    ResetUserComponent,
    NavigationTopComponent,
    NavigationSubmenuComponent,
    BulkTransfersComponent,
    DropdownSelectControlComponent,
    ThreeStarsPipe,
    HelpFilterPipe,
    MessagesComponent,
    VisitorCardAdjustmentsComponent,
    SearchResultsComponent,
    VisitorCardSearchResultsComponent,
    VisitorCardAccountDetailsComponent,
    VisitorCardsTransactionHistoryComponent,
    ConfirmButtonComboComponent,
    Last4digitsPipe,
    MerchantVisahistoryComponent,
    CardholderAccountDetailsComponent,
    CardholderHistoryComponent,
    CardholderOpenLoopHistoryComponent,
    GetKeysPipe,
    AccessDetailsComponent,
    SelfEnrollComponent,
    ProgressBarComponent,
    ServiceAndTermsComponent,
    ESignComponent,
    InformationComponent,
    CopyRightComponent,
    ESignPdfComponent,
    TermsPdfComponent,
    TermsLongPdfComponent,
    TermsShortPdfComponent,
    EmailVerificationComponent,
    VerificationInactiveComponent,
    VerificationInvalidComponent,
    VerificationValidComponent,
    ModalComponent,
    ShipPendingComponent,
    PrivacyComponent,
    MerchantFormsComponent,
    DropzoneDirective,
    FileUploaderComponent,
    MaintainShipUserComponent,
    ShipUserFormComponent,
    VisaReportsComponent
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DateParserFormatter },
    { provide: FormUtils, useClass: FormUtils },
    NgbActiveModal
  ],
  exports: [
    AchfundingComponent,
    CardholderAdjustmentsComponent,
    CardholderNotesComponent,
    CardholderVisaforwardComponent,
    CardholderFormsHistoryComponent,
    CardholderVisahistoryComponent,
    FleetInformationComponent,
    RoundTripHistoryComponent,
    RoundTripOverviewComponent,
    ShipHeaderSearchComponent,
    ShipSearchResultsComponent,
    MerchantSearchResultsComponent,
    PaginationComponent,
    RouterModule,
    MerchantAccountsComponent,
    MerchantDetailsComponent,
    MerchantHistoryComponent,
    MerchantSettlementComponent,
    MerchantVisaforwardComponent,
    MerchantProfilesComponent,
    MerchantNotesComponent,
    MerchantAchFundingComponent,
    MerchantAdjustmentsComponent,
    WebAlertComponent,
    BulkTransfersComponent,
    ShipProfilesComponent,
    NavigationFooterComponent,
    NavigationSidebarFooterComponent,
    NavigationSidebarComponent,
    FormsUploadComponent,
    FormsViewSearchComponent,
    SearchFormExistsComponent,
    ShipReportsComponent,
    BulkCardsComponent,
    ShipContactsComponent,
    HullSwapsComponent,
    ShipMerchantsComponent,
    RoundTripsComponent,
    ShipDetailsComponent,
    ShipPasswordComponent,
    ShipRegisterComponent,
    MerchantSearchComponent,
    ResetUserComponent,
    NavigationTopComponent,
    NavigationSubmenuComponent,
    BulkTransfersComponent,
    DropdownSelectControlComponent,
    ThreeStarsPipe,
    HelpFilterPipe,
    ActiveInactivePipe,
    YesNoPipe,
    MinusSignToParensPipe,
    YesNoStatusPipe,
    SortPipe,
    AccountTypePipe,
    BankingTypePipe,
    CircleGreenRedPipe,
    MessagesComponent,
    SearchResultsComponent,
    VisitorCardAccountDetailsComponent,
    ConfirmButtonComboComponent,
    Last4digitsPipe,
    GetKeysPipe,
    AccessDetailsComponent,
    SelfEnrollComponent,
    ProgressBarComponent,
    ESignPdfComponent,
    TermsPdfComponent,
    EmailVerificationComponent,
    VerificationInactiveComponent,
    VerificationInvalidComponent,
    VerificationValidComponent,
    ModalComponent,
    CommonModule,
    Ng2TableModule,
    ToastrModule,
    MerchantFormsComponent,
    DropzoneDirective,
    FileUploaderComponent,
    MaintainShipUserComponent,
    VisaReportsComponent
  ]
})
export class AppRoutingModule {}
